import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}`,
  withCredentials: true,
});

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getDestinations = () => api.get("/destinations").then((r) => r.data);
export const getDestination = (slug) =>
  api.get(`/destinations/${slug}`).then((r) => r.data);
export const getPackages = (params) =>
  api.get("/packages", { params }).then((r) => r.data);
export const getPackage = (slug) =>
  api.get(`/packages/${slug}`).then((r) => r.data);
export const getFaqs = () => api.get("/faqs").then((r) => r.data);
export const postInquiry = (data) =>
  api.post("/inquiries", data).then((r) => r.data);
export const postTrack = (data) =>
  api.post("/track", data).catch(() => {});
export const postUpload = (formData) =>
  api.post("/admin/upload", formData).then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export default api;
